import React, { useRef, useState } from 'react';
import Slider from 'react-slick';
import FullscreenImageSlider from '../FullscreenImageSlider/FullscreenImageSlider';
import Icon from '../IconBase/Icon';
import SliderThumbnails from '../SliderThumbnails/SliderThumbnails';
import(`./styles/${window.__litium.themeName}.scss`);

const ProductImageContainer = ({ productImages }) => {
  const singleSlide = productImages.length === 1;
  const sliderRef = useRef();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showFullscreenImages, setShowFullscreenImages] = useState(false);
  const [isSliding, setIsSliding] = useState(false);

  const next = () => {
    sliderRef.current.slickNext();
  };
  const prev = () => {
    sliderRef.current.slickPrev();
  };

  var settings = {
    afterChange: () => {
      setIsSliding(false);
    },
    beforeChange: (_, index) => {
      setCurrentSlide(index);
    },
    speed: 200,
    dots: false,
    arrows: false,
    infinite: false,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    onSwipe: () => setIsSliding(true),
  };

  return (
    <div className="product-images">
      <div className="product-images__container">
        {!singleSlide && (
          <div
            className={`product-images__arrow product-images__arrow--prev ${
              currentSlide < 1 ? 'product-images__arrow--disabled' : ''
            }`}
            onClick={prev}
          >
            <Icon
              className="product-images__arrow__icon"
              iconCode="chevron_left"
            />
          </div>
        )}
        <Slider ref={sliderRef} {...settings}>
          {productImages.length > 0 &&
            productImages.map((productImage, i) => (
              <div key={'product-image-' + i}>
                <div className="product-images__image-container">
                  <img
                    className="product-images__image"
                    src={productImage.slideUrl}
                    alt={productImage.alt}
                    onClick={() => !isSliding && setShowFullscreenImages(true)}
                  />
                </div>
              </div>
            ))}
        </Slider>
        {!singleSlide && (
          <div
            className={`product-images__arrow product-images__arrow--next ${
              currentSlide >= productImages.length - 1
                ? 'product-images__arrow--disabled'
                : ''
            }`}
            onClick={next}
          >
            <Icon
              className="product-images__arrow__icon"
              iconCode="chevron_right"
            />
          </div>
        )}
      </div>
      {!singleSlide && (
        <SliderThumbnails
          className="product-images__thumbnails"
          images={productImages}
          sliderRef={sliderRef}
          activeSlide={currentSlide}
        />
      )}
      {!singleSlide && (
        <div className="product-images__count-container">
          {currentSlide + 1} / {productImages.length}
        </div>
      )}
      {showFullscreenImages && (
        <FullscreenImageSlider
          images={productImages}
          onClosed={() => setShowFullscreenImages(false)}
          initialSlide={currentSlide}
          infinite={false}
        />
      )}
    </div>
  );
};

export default ProductImageContainer;
